const Navbar = ({ setAlgorithm, runSort }) => {
  return (
    <div className="p-4 bg-blue-600 text-white flex justify-between items-center">
      <h1 className="text-xl font-bold">Sorting Visualizer</h1>
      <div className="flex gap-3">
        <select onChange={(e) => setAlgorithm(e.target.value)} className="text-black p-1 rounded">
          <option value="bubble">Bubble Sort</option>
          <option value="merge">Merge Sort</option>
          <option value="quick">Quick Sort</option>
        </select>
        <button onClick={runSort} className="bg-white text-blue-600 px-3 py-1 rounded">Sort</button>
      </div>
    </div>
  );
};

export default Navbar;